<template>
  <div>
    <div class="navBar">
      <div class="navBarLeft">
        <p>
          <img :src="logo"/>
        </p>

      </div>
      <div class="navBarCenter">
        <p>{{ companyName }}报表</p>
      </div>
      <div class="navBarRight">
        <p class="updateTimeCont">最后更新：{{ updateTime }}</p>
        <p>数据来源：多平台聚合</p>
      </div>
    </div>

    <div class="homePageCont">
      <el-row :gutter="20">
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <div class="enterpriseInformation">
              <div class="enterpriseInformationCont">
                <p class="enterpriseInformationContTop">
                  <span><img src="../assets/img/08.png"/></span>
                  <span>{{ companyName }}</span>
                </p>
                <p class="enterpriseInformationContBot"><span><img
                  src="../assets/img/phone.png"/> </span><span>电话：</span><span>{{ phone }}</span></p>
                <p class="enterpriseInformationContBot"><span><img
                  src="../assets/img/email.png"/></span><span>邮箱：</span><span>{{ email }}</span></p>
                <p class="enterpriseInformationContBot"><span><img
                  src="../assets/img/url.png"/></span><span>网址：</span><span>{{ website }}</span></p>
              </div>
            </div>
            <div class="rankingPercentageData">
              <p class="dataTitle"><span class="titleLine"></span>平台排名占比数据</p>
              <div class="rankingPercentageDataCont">
                <div ref="chart" style="width: 100%; height: 260px;"></div>
              </div>
            </div>
            <div class="keywordRecordData">
              <p class="dataTitle"><span class="titleLine"></span>关键词排名</p>
              <div class="keywordRecordDataCont">
                <canvas
                  ref="rankingCanvas"
                  class="canvas-container"
                ></canvas>
              </div>

            </div>
          </div>
        </el-col>
        <el-col :span="14"><div class="grid-content bg-purple">
          <div class="keywordNum">
            <div class="keywordNumTitle">
              <p><span class="titleLine"></span>关键词数量</p>

            </div>
            <div class="keywordNumCont">
              <ul>
                <li>
                  <p>核心关键词</p>
                  <p>{{keywordCoreList.length}}</p>
                </li>
                <li>
                  <p>蒸馏关键词</p>
                  <p>{{rankCount}}</p>
                </li>
                <li>
                  <p>品牌关键词</p>
                  <p>{{brandCount}}</p>
                </li>
                <li>
                  <p>总收录条数</p>
                  <p>{{countAll}}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="homePageContList">
            <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item, index) in activeNameList" :key=' index' :label="item.ai_name"
                           :name="String(item.id)"></el-tab-pane>
            </el-tabs>
            <div class="search-container">
              <div
                class="search-option"
                :class="{ active: currentTab === 'keyword' }"
                @click="switchTab('keyword')"
              >
                关键词搜索
              </div>
              <div
                class="search-option"
                :class="{ active: currentTab === 'brand' }"
                @click="switchTab('brand')"
              >
                品牌搜索
              </div>
              <div
                class="search-option"
                :class="{ active: currentTab === 'scene' }"
                @click="switchTab('scene')"
              >
                语句搜索
              </div>
<!--              <div-->
<!--                class="search-option"-->
<!--                :class="{ active: currentTab === 'contact' }"-->
<!--                @click="switchTab('contact')"-->
<!--              >-->
<!--                联系方式-->
<!--              </div>-->
            </div>
            <div class="screeningCondition">
              <div>
                <el-select v-model="keyword_core" placeholder="请选择核心产品词" @change="keywordCoreChange" clearable class="custom-select" v-if="currentTab === 'keyword'">
                  <el-option
                    v-for="item in keywordCoreList"
                    :key="item.keywords_core"
                    :label="item.keywords_core"
                    :value="item.keywords_core">
                  </el-option>
                </el-select>
              </div>
              <div class="chooseSource">
                <el-button @click="switchPlatformTab(2)" :class="{ activeSource: selectedSource.includes(2) }">移动端</el-button>
                <el-button @click="switchPlatformTab(1)" :class="{ activeSource: selectedSource.includes(1) }">PC端</el-button>
              </div>

            </div>
            <div style="padding: 0 20px;">
              <el-table
                :data="tableData"
                stripe
                style="width: 100%;margin-top:10px;"
                align="center"
                :row-class-name="setRowClassName"
              >
                <el-table-column
                  prop="keywords_core"
                  label="核心产品词" v-if="currentTab === 'keyword' || currentTab==='contact'">
                </el-table-column>
                <el-table-column
                  prop="keywords"
                  label="品牌拓展词" v-if="currentTab === 'brand'">
                </el-table-column>
                <el-table-column
                  prop="keywords"
                  label="场景" v-if="currentTab === 'scene'">
                </el-table-column>
                <el-table-column
                  prop="keywords"
                  label="场景搜索词" v-if="currentTab === 'keyword' || currentTab==='contact'">
                </el-table-column>
                <el-table-column
                  prop="client"
                  label="来源"
                  v-if="currentTab === 'keyword' || currentTab === 'brand' || currentTab === 'scene' || currentTab === 'contact'">
                  <template slot-scope="scope">
                    <span v-if="scope.row.client==2">移动端</span>
                    <span v-if="scope.row.client==1">PC端</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="instrument_id"
                  label="平台"
                  v-if="currentTab === 'keyword' || currentTab === 'brand' || currentTab === 'scene' || currentTab === 'contact'">
                  <template slot-scope="scope">
                    <span v-if="scope.row.instrument_id==1">豆包</span>
                    <span v-if="scope.row.instrument_id==2">文心一言</span>
                    <span v-if="scope.row.instrument_id==3">DeepSeek</span>
                    <span v-if="scope.row.instrument_id==4">Kimi</span>
                    <span v-if="scope.row.instrument_id==5">腾讯元宝</span>
                    <span v-if="scope.row.instrument_id==6">通义千问</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="update_time"
                  label="查询时间"
                  v-if="currentTab === 'keyword' || currentTab === 'brand' || currentTab === 'scene' || currentTab === 'contact'">
                </el-table-column>
                <el-table-column
                  v-if="currentTab === 'keyword'"
                  label="操作">
                  <template slot-scope="scope"><span v-if="scope.row.instrument_id!==5 && scope.row.rank_search_id!==0" @click="printscreenClick(scope.row)" style="color: #8D7DFE;cursor: pointer;display: inline-block;border-bottom: 1px solid #8D7DFE;">详情</span></template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20, 30, 50]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
        </el-col>

      </el-row>


    </div>
    <div class="specialDeclaration">
      <p>特别申明：Ai大模型搜索结果千人千面，报表检测结果以系统IP检测结果为准，若有波动也属于合理范围，可以尝试多个设备进行检索!</p>
    </div>
    <el-dialog title="详情" :visible.sync="dialogVisible" width="800px">
      <div class="detailsCont">
        <p class="detailsContKeywords"><span>{{detailsContObj.keywords}}</span></p>
        <p class="detailsContPlatform">
          <span v-if="detailsContObj.instrument_id==1"><img src="../assets/img/25.png" />豆包</span>
          <span v-if="detailsContObj.instrument_id==2"><img src="../assets/img/27.png" />文心一言</span>
          <span v-if="detailsContObj.instrument_id==3"><img src="../assets/img/24.png" />DeepSeek</span>
          <span v-if="detailsContObj.instrument_id==4"><img src="../assets/img/26.png" />Kimi</span>
          <span v-if="detailsContObj.instrument_id==5">腾讯元宝</span>
          <span v-if="detailsContObj.instrument_id==6"><img src="../assets/img/28.png" />通义千问</span>
        </p>
        <div v-html="detailsContObj.answer" class="detailsContAnswer"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import axios from "axios";

export default {
  name: 'Index',
  data() {
    return {
      code: '',
      logo: require('../assets/img/01.png'),
      companyName: '',
      updateTime: '',
      sector: '',//所属行业
      product: '',//主要产品
      phone: '',//电话
      email: '',//邮箱
      website: '',//网址
      imgUrl1: require('../assets/img/09.png'),
      imgUrl2: require('../assets/img/10.png'),
      imgUrl3: require('../assets/img/12.png'),
      imgUrl4: require('../assets/img/13.png'),
      imgUrl5: require('../assets/img/14.png'),
      imgUrl6: require('../assets/img/11.png'),
      rankCount:'',//蒸馏关键词
      brandCount:'',//品牌关键词
      countAll:'',//总收录条数
      keywordNumList: [],
      keywordData: [],//关键词排名
      canvas: null,
      ctx: null,
      // 基础配置（可根据屏幕尺寸动态调整）
      config: {
        barHeight: 12, // 条形高度
        gap: 30, // 条形间距
        fontSize: 14, // 文字大小
        paddingLeft: 130, // 左侧文字区域宽度
        paddingRight: 50, // 右侧数值区域宽度
        // PC端特有配置
        pcMaxWidth: 1000, // PC端最大宽度限制
        mobileBreakPoint: 768, // 移动端断点
      },
      resizeHandler: null,
      oneMonthNum: '',
      threeMonthNum: '',
      oneYearNum: '',
      activeName: '0',
      activeNameList: [{
        id: 0,
        ai_name: '全部'
      }],
      currentTab: 'keyword', // 默认选中关键词搜索
      instrument_id: 0,
      page: 1,
      limit: 50,
      total: 0,
      tableData: [],
      client: 0,//全部来源
      keywordCoreList:[],//筛选核心产品词
      keyword_core:'',
      selectedSource:[],
      semanticSearchData: [],//语句搜索
      semanticSearchPage: 1,
      semanticSearchLimit: 50,
      semanticSearchTotal: 0,
      chart: null,
      chartDataObj: {
        pageSourceList: [],
        numberList: []
      },
      platformListObj: {
        pageSourceList: [],
        numberList: []
      },//平台排名占比数据
      barIconPath: require('../assets/img/20.png'),
      dialogVisible:false,
      detailsContObj:{
        keywords:'',
        instrument_id:'',
        answer:''
      },
      url: 'https://geo-api.niushi.cc/report',
      contactList:[],//联系方式
      contactIdList:[],//联系方式
      allData:[]
    }
  },
  created() {
    if (document.domain=='geo.kbyun.com'){
      this.logo = require('../assets/img/02.png')
    }else{
      this.logo = require('../assets/img/01.png')
    }
    if (this.getQueryString("code") != -1) {
      if (this.getQueryString("code") == "null" || this.getQueryString("code") == "" || this.getQueryString("code") == null) {
        this.code = ''
      } else {
        this.code = this.getQueryString("code");
        this.getInfo();
        this.getInstrumentList();
        this.getStatisticsInfo();
        this.instrument_id = 0;
        this.getRankKeywords(this.instrument_id)
      }
    }

  },
  mounted() {
    let url = 'http://'+document.domain
    let goUrl = this.isMobile();
    if (goUrl === 1) {
      //移动端地址
      location =url+'/mobile/?#/mobile?code='+this.code;
    }else{
      location =url+'/#/?code='+this.code;
    }
  },
  methods: {
    getInfo() {
      let that = this;
      let data = {
        code: this.code
      }
      axios.get(this.url + '/info',
        {
          params: data
        },
      )
        .then(function (res) {
          let data = res.data;
          if (data.code == 1) {
            that.companyName = data.data.company;
            that.product = data.data.product;
            that.sector = data.data.sector;
            that.phone = data.data.phone_ai;
            that.email = data.data.email;
            that.website = data.data.url;
          }
        })
    },
    getStatisticsInfo() {
      let that = this;
      that.keywordCoreList = [];
      let data = {
        code: this.code
      }
      axios.get(this.url + '/statistics/info',
        {
          params: data
        },
      )
        .then(function (res) {
          let data = res.data;
          if (data.code == 1) {
            that.updateTime = data.data.update_time;
            that.oneMonthNum = data.data.article.num_1;
            that.threeMonthNum = data.data.article.num_90;
            that.oneYearNum = data.data.article.num_365;
            that.rankCount = data.data.rank_count;
            that.brandCount = data.data.brand_count;
            that.countAll = data.data.count_all;
            if (data.data.report.length > 0) {
              let reportList = data.data.report;
              for (let i = 0; i < reportList.length; i++) {
                for (let j = 0; j < that.keywordNumList.length; j++) {
                  that.keywordNumList[j].count = reportList[j].count
                  that.keywordNumList[j].percent = reportList[j].percent
                }
              }
              that.$nextTick(() => {
                // that.initChart(); // 确保DOM已渲染
                that.initChart1();

              });

            }

            if (data.data.keywords_core.length > 0) {
              that.keywordCoreList = data.data.keywords_core;
              let keywordsCoreList = data.data.keywords_core;
              if (keywordsCoreList.length > 7) {
                that.keywordData = keywordsCoreList.slice(0, 7);
              } else {
                that.keywordData = keywordsCoreList;
              }
              // 移除旧的resize监听（避免重复绑定）
              window.removeEventListener('resize', that.handleResizeRankingChart);
              // 绑定新的resize监听，并使用节流优化PC端性能
              const throttleResize = that.throttle(that.handleResizeRankingChart, 100); // 节流函数
              window.addEventListener('resize', throttleResize);
              that.resizeHandler = throttleResize; // 保存引用，方便销毁时移除
              that.$nextTick(() => {
                that.initCanvas();
                that.handleResizeRankingChart();
                that.drawRankingChart();

              });
            }else{
              that.keywordData = [];
            }
          }
        })
    },
    throttle(fn, delay) {
      let lastTime = 0;
      return function(...args) {
        const now = Date.now();
        if (now - lastTime > delay) {
          fn.apply(this, args);
          lastTime = now;
        }
      };
    },
    getInstrumentList() {
      let that = this;
      that.keywordNumList = [];
      let data = {
        code: this.code
      }
      axios.get(this.url + '/get_instrument_list',
        {
          params: data
        },
      )
        .then(function (res) {
          let data = res.data;
          if (data.data.length > 0) {
            that.keywordNumList = data.data;
            for (let i = 0; i < that.keywordNumList.length; i++) {
              if (that.keywordNumList[i].ai_name == '豆包') {
                that.keywordNumList[i].imgUrl = that.imgUrl1;
              } else if (that.keywordNumList[i].ai_name == '文心一言') {
                that.keywordNumList[i].imgUrl = that.imgUrl2;
              } else if (that.keywordNumList[i].ai_name == 'DeepSeek') {
                that.keywordNumList[i].imgUrl = that.imgUrl3;
              } else if (that.keywordNumList[i].ai_name == 'Kimi') {
                that.keywordNumList[i].imgUrl = that.imgUrl4;
              } else if (that.keywordNumList[i].ai_name == '腾讯元宝') {
                that.keywordNumList[i].imgUrl = that.imgUrl5;
              } else if (that.keywordNumList[i].ai_name == '通义千问') {
                that.keywordNumList[i].imgUrl = that.imgUrl6;
              }
            }
            that.activeNameList.push(...that.keywordNumList)
          }
        })

    },

    initChart() {
      const chart = echarts.init(this.$refs.chart)
// 创建渐变色函数
      const createGradient = (startColor, endColor) => {
        return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {offset: 0, color: startColor},
          {offset: 1, color: endColor}
        ])
      }
      // 定义各平台渐变颜色
      const platformGradients = {
        '豆包': createGradient('#5F82FF', '#A5B8FF'),
        '文心一言': createGradient('#009DEE', '#66CDFF'),
        'DeepSeek': createGradient('#9276FE', '#C9B8FF'),
        'Kimi': createGradient('#F0BC1B', '#FFD966'),
        '腾讯元宝': createGradient('#0FDA97', '#7CECBF'),
        '通义千问': createGradient('#BA5DFF', '#D9A5FF')
      }
      for (let i = 0; i < this.keywordNumList.length; i++) {
        const platformName = this.keywordNumList[i].ai_name
        const gradient = platformGradients[platformName] || createGradient('#999', '#CCC')

        this.chartDataObj.pageSourceList.push(platformName)
        let obj = {
          value: this.keywordNumList[i].count,
          name: platformName,
          itemStyle: {
            color: gradient
          }
        }
        this.chartDataObj.numberList.push(obj)
        const option = {
          title: {
            text: '',
            left: 'center',
            textStyle: {
              fontSize: 16,
              fontWeight: 'bold'
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: this.chartDataObj.pageSourceList,
            axisLabel: {
              rotate: 0, // 如果标签太长可以旋转
              interval: 0 // 显示所有标签
            },
            name: '',
            nameLocation: 'middle',
            nameGap: 30
          },
          yAxis: {
            type: 'value',
            name: '',
            min: 0,
            // max: 100,
            interval: 500,
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              lineStyle: {
                color: '#ccc',
                type: 'dashed'
              }
            }
          },
          series: [{
            name: '',
            type: 'bar',
            barWidth: 30,
            data: this.chartDataObj.numberList,
            label: {
              show: true,
              position: 'top'
            }
          }]
        }
        chart.setOption(option)
        // 响应式调整
        window.addEventListener('resize', function () {
          chart.resize()
        })
      }
    },
    initCanvas() {
      this.canvas = this.$refs.rankingCanvas;
      this.ctx = this.canvas.getContext('2d');
      // 初始化尺寸
      this.handleResizeRankingChart();
    },
    handleResizeRankingChart() {
      const container = this.$refs.rankingCanvas;
      let wrapperWidth = container.clientWidth;
      const { pcMaxWidth, mobileBreakPoint } = this.config;
      const dpr = window.devicePixelRatio || 1;

      // 确保最小宽度，避免Canvas太小
      const minWidth = 300; // 最小宽度防止字体模糊
      wrapperWidth = Math.max(wrapperWidth, minWidth);

      // PC端限制最大宽度
      if (window.innerWidth >= mobileBreakPoint) {
        wrapperWidth = Math.min(wrapperWidth, pcMaxWidth);
      }

      // 计算逻辑高度 - 确保有最小高度
      const minRows = 3; // 即使只有1条数据，也保留最小行数的高度
      const dataLength = Math.max(this.keywordData.length, minRows);
      const logicalHeight = 20 + dataLength * (
        window.innerWidth >= mobileBreakPoint
          ? this.config.barHeight + this.config.gap + 5
          : this.config.barHeight + this.config.gap
      );

      // 设置Canvas实际像素尺寸
      this.canvas.width = wrapperWidth * dpr;
      this.canvas.height = logicalHeight * dpr;

      // 设置CSS显示尺寸
      this.canvas.style.width = wrapperWidth + 'px';
      this.canvas.style.height = logicalHeight + 'px';

      // 关键：缩放上下文，并设置字体大小
      this.ctx.scale(dpr, dpr);

      // 设置清晰的字体
      this.setClearFont();

      if (this.keywordData.length) {
        this.drawRankingChart();
      }
    },

// 新增：设置清晰字体
    setClearFont() {
      const isPC = window.innerWidth >= this.config.mobileBreakPoint;
      const fontSize = isPC ? this.config.fontSize + 2 : this.config.fontSize;

      // 优化字体栈，确保有清晰的字体可用
      const fontStack = `
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    'Helvetica Neue',
    Arial,
    sans-serif
  `;

      this.ctx.font = `${fontSize}px ${fontStack}`;
      this.ctx.fillStyle = '#333';
      this.ctx.textBaseline = 'middle';

      // 开启字体平滑
      this.ctx.imageSmoothingEnabled = true;
      this.ctx.imageSmoothingQuality = 'high';
    },
    // 绘制排名图表
    drawRankingChart() {
      const { ctx, canvas, config, keywordData } = this;
      const dpr = window.devicePixelRatio || 1;
      const isPC = window.innerWidth >= config.mobileBreakPoint;

      // 清除画布
      ctx.clearRect(0, 0, canvas.width / dpr, canvas.height / dpr);

      // 设置字体
      const fontSize = isPC ? config.fontSize + 2 : config.fontSize;
      const fontFamily = 'Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif';
      ctx.font = `bold ${fontSize}px ${fontFamily}`;

      // 计算条形区域可用宽度
      const canvasWidth = canvas.width / dpr;

      // 方案三特点：
      // 1. 左侧文字区域固定宽度，完整显示
      // 2. 中间进度条区域缩短
      // 3. 右侧数字区域固定宽度

      // 重新分配宽度比例
      const leftTextWidth = 180; // 左侧文字区域固定宽度（根据最长文字调整）
      const rightNumberWidth = 80; // 右侧数字区域固定宽度
      const progressBarWidth = canvasWidth - leftTextWidth - rightNumberWidth - 30; // 中间进度条区域（缩短）

      const maxValue = Math.max(...keywordData.map(item => item.num));
      const startY = 10; // 起始Y坐标

      keywordData.forEach((item, index) => {
        const rowHeight = config.barHeight + config.gap;
        const y = startY + index * rowHeight;

        // 1. 绘制左侧文字（完整显示，不加省略号）
        ctx.fillStyle = '#333';
        ctx.textAlign = 'left'; // 左对齐
        ctx.textBaseline = 'middle';

        // 完整显示文字，不截断
        const text = item.keywords_core;
        ctx.fillText(
          text,
          10, // 左侧起始位置
          y + config.barHeight / 2
        );

        // 2. 绘制条形背景（缩短的进度条区域）
        const barStartX = leftTextWidth + 10; // 进度条起始位置
        ctx.fillStyle = '#f5f5f5';

        if (isPC) {
          this.drawRoundedRect(ctx, barStartX, y, progressBarWidth, config.barHeight, 4);
          ctx.fill();
        } else {
          ctx.fillRect(barStartX, y, progressBarWidth, config.barHeight);
        }

        // 3. 绘制彩色进度条（缩短）
        const barWidth = (item.num / maxValue) * progressBarWidth;
        if (barWidth > 0) {
          // 使用图片中的紫色渐变
          const gradient = ctx.createLinearGradient(
            barStartX, y,
            barStartX + barWidth, y
          );
          gradient.addColorStop(0, '#ECADFF');
          gradient.addColorStop(0.5, '#BA5DFF');
          gradient.addColorStop(1, '#BA5DFF');

          ctx.fillStyle = gradient;

          if (isPC) {
            this.drawRoundedRect(ctx, barStartX, y, barWidth, config.barHeight, 4);
            ctx.fill();
          } else {
            ctx.fillRect(barStartX, y, barWidth, config.barHeight);
          }

          // 添加进度条末端的浅色圆点（如图片所示）
          ctx.fillStyle = '#FFFFFF';
          ctx.beginPath();
          ctx.arc(barStartX + barWidth, y + config.barHeight / 2, 3, 0, Math.PI * 2);
          ctx.fill();
        }

        // 4. 绘制右侧数字
        ctx.fillStyle = '#333';
        ctx.textAlign = 'right'; // 右对齐
        ctx.font = `bold ${fontSize}px ${fontFamily}`;

        const numberText = item.num.toString();
        const numberX = canvasWidth - 10; // 右侧位置

        ctx.fillText(
          numberText,
          numberX,
          y + config.barHeight / 2
        );

        // 5. 绘制分隔线（如图片中的白色分隔线）
        // if (index < keywordData.length - 1) {
        //   ctx.strokeStyle = '#E0E0E0';
        //   ctx.lineWidth = 1;
        //   ctx.beginPath();
        //   ctx.moveTo(10, y + config.barHeight + config.gap / 2);
        //   ctx.lineTo(canvasWidth - 10, y + config.barHeight + config.gap / 2);
        //   ctx.stroke();
        // }
      });

      // 6. 绘制标题（如图片中的"关键词排名"）
      ctx.fillStyle = '#8A2BE2';
      ctx.font = `bold ${fontSize + 4}px ${fontFamily}`;
      ctx.textAlign = 'left';
      // ctx.fillText('关键词排名', 10, 0);
    },

// 新增：绘制圆角矩形方法（PC端专用）
    drawRoundedRect(ctx, x, y, width, height, radius) {
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.arcTo(x + width, y, x + width, y + height, radius);
      ctx.arcTo(x + width, y + height, x, y + height, radius);
      ctx.arcTo(x, y + height, x, y, radius);
      ctx.arcTo(x, y, x + width, y, radius);
      ctx.closePath();
      ctx.fill();
    },

    initChart1() {
      for (let i = 0; i < this.keywordNumList.length; i++) {
        this.platformListObj.pageSourceList.push(this.keywordNumList[i].ai_name)
        let obj = {
          value: this.keywordNumList[i].percent,
          name: this.keywordNumList[i].ai_name,
          itemStyle: {color: ''},
          label: {
            show: false,
            position: 'inside',
            formatter: '{c}',
            color: '#fff',
            fontWeight: 'bold'
          }
        }
        this.platformListObj.numberList.push(obj)
      }
      for (let i = 0; i < this.platformListObj.numberList.length; i++) {
        if (this.platformListObj.numberList[i].name == '豆包') {
          this.platformListObj.numberList[i].itemStyle.color = '#5F82FF'
        } else if (this.platformListObj.numberList[i].name == '文心一言') {
          this.platformListObj.numberList[i].itemStyle.color = '#009DEE'
        } else if (this.platformListObj.numberList[i].name == 'DeepSeek') {
          this.platformListObj.numberList[i].itemStyle.color = '#9276FE'
        } else if (this.platformListObj.numberList[i].name == 'Kimi') {
          this.platformListObj.numberList[i].itemStyle.color = '#F0BC1B'
        } else if (this.platformListObj.numberList[i].name == '腾讯元宝') {
          this.platformListObj.numberList[i].itemStyle.color = '#0FDA97'
        } else if (this.platformListObj.numberList[i].name == '通义千问') {
          this.platformListObj.numberList[i].itemStyle.color = '#BA5DFF'
        } else {

        }
      }

      this.chart = echarts.init(this.$refs.chart)
      const total = this.platformListObj.numberList.reduce((sum, item) => sum + item.value, 0)
      const option = {
        tooltip: {
          trigger: 'item',
          // 使用 ECharts 内置的百分比变量 {d}
          formatter: '{a}<br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          formatter: (name) => {
            const data = this.platformListObj.numberList.find(item => item.name === name)
            if (data) {
              const total = this.platformListObj.numberList.reduce((sum, item) => sum + item.value, 0)
              const percent = ((data.value / total) * 100).toFixed(2)
              return `${name} ${percent}%`
            }
            return name
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            center: ['40%', '50%'],
            label: {
              // 按照图片中的配置
              show: true,  // 图片中是false
              position: 'outside',
              formatter: function(params) {
                // params.data就是原始数据项
                const percent = ((params.value / total) * 100).toFixed(2)
                return `${params.name}\n${percent}%`
              },
              color: '#333',
              fontWeight: 'bold'
            },
            // 标签线配置
            labelLine: {
              show: true,
              length: 15,
              length2: 20
            },
            data: this.platformListObj.numberList.map(item => ({
              name: item.name,
              value: item.value,
              itemStyle: {
                color: item.itemStyle.color
              }
            }))
          }
        ],
      }

      this.chart.setOption(option)
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    handleClick(tab, event) {
      this.instrument_id = tab.name
      this.page = 1;
      if (this.currentTab === 'keyword') {
        this.getRankKeywords(this.instrument_id)
      } else if (this.currentTab === 'scene') {
        this.getRankScene(this.instrument_id)
      } else if (this.currentTab === 'brand') {
        this.getRankBrand(this.instrument_id)
      } else if (this.currentTab === 'contact') {
        this.getContactList()
      } else {
      }
    },
    switchTab(tab) {
      this.page = 1;
      this.currentTab = tab;
      if (tab === 'keyword') {
        this.getRankKeywords(this.instrument_id)
      } else if (tab === 'brand') {
        this.getRankBrand(this.instrument_id)
      } else if (tab === 'scene') {
        this.getRankScene(this.instrument_id)
      } else if (tab === 'contact') {
        this.getContactList()
      } else {
      }
    },
    switchPlatformTab(val) {
      const index = this.selectedSource.indexOf(val);
      if (index > -1) {
        // 已选中，移除
        this.selectedSource.splice(index, 1);
      } else {
        // 未选中，添加
        this.selectedSource.push(val);
      }
      if(this.selectedSource.length==2){
        this.client = 0;
      }else if(this.selectedSource.length==1){
        this.client = this.selectedSource[0];
      }else{
        this.client = 0;
      }
      this.page = 1;
      if (this.currentTab === 'keyword') {
        this.getRankKeywords(this.instrument_id)
      } else if (this.currentTab === 'scene') {
        this.getRankScene(this.instrument_id)
      } else if (this.currentTab === 'brand') {
        this.getRankBrand(this.instrument_id)
      } else if (this.currentTab === 'contact') {
        this.getContactList()
      } else {
      }
    },
    keywordCoreChange(){
      this.page = 1;
      if (this.currentTab === 'keyword') {
        this.getRankKeywords(this.instrument_id)
      } else if (this.currentTab === 'scene') {
        this.getRankScene(this.instrument_id)
      }  else if (this.currentTab === 'brand') {
        this.getRankBrand(this.instrument_id)
      } else if (this.currentTab === 'contact') {
        this.getContactList()
      } else {
      }
    },
    setRowClassName({rowIndex}) {
      let className = '';
      if (rowIndex % 2 !== 0) className += 'odd-row';   // 奇数行添加类名
      return className;
    },
    //获取关键词列表
    getRankKeywords(id) {
      let that = this;
      that.tableData = [];
      let data = {
        code: this.code,
        instrument_id: id,
        keyword_core:this.keyword_core,
        client: this.client,
        page: this.page,
        limit: this.limit
      }
      axios.get(this.url + '/rank_keywords',
        {
          params: data
        },
      )
        .then(function (res) {
          let data = res.data;
          if (data.code == 1) {
            if (data.data.length > 0) {
              that.total = data.count;
              that.tableData = data.data;
              that.allData = [...that.allData, ...data.data];
            } else {
              that.total = 0;
              that.tableData = [];
            }
          } else {
            that.total = 0;
          }
        })

    },
    //获取语句搜索内容
    getRankScene(id) {
      let that = this;
      that.tableData = [];
      let data = {
        code: this.code,
        instrument_id: id,
        keyword_core:this.keyword_core,
        client: this.client,
        page: this.page,
        limit: this.limit
      }
      axios.get(this.url + '/rank_scene',
        {
          params: data
        },
      )
        .then(function (res) {
          let data = res.data;
          if (data.code == 1) {
            if (data.data.length > 0) {
              that.total = data.count;
              that.tableData = data.data;
              that.allData = [...that.allData, ...data.data];
            } else {
              that.total = 0;
              that.tableData = [];
            }
          } else {
            that.total = 0;
          }
        })
    },
    getRankBrand(id){
      let that = this;
      that.tableData = [];
      let data = {
        code: this.code,
        instrument_id: id,
        keyword_core:this.keyword_core,
        client: this.client,
        page: this.page,
        limit: this.limit
      }
      axios.get(this.url + '/rank_brand',
        {
          params: data
        },
      )
        .then(function (res) {
          let data = res.data;
          if (data.code == 1) {
            if (data.data.length > 0) {
              that.total = data.count;
              that.tableData = data.data;
              that.allData = [...that.allData, ...data.data];
            } else {
              that.total = 0;
              that.tableData = [];
            }
          } else {
            that.total = 0;
          }
        })
    },
    // 获取联系方式列表
    getContactList() {
      let that = this;
      that.tableData = [];
      that.total = 0;
      // 如果有已记录的包含联系方式的ID
      if (that.contactIdList.length > 0) {
        // 从所有数据中筛选出包含联系方式的记录
        // 这里需要根据实际数据源实现
        that.tableData = that.allData.filter(item =>
          that.contactIdList.includes(item.rank_search_id)
        );
        // 去重逻辑
        that.tableData = that.tableData.reduce((unique, item) => {
          if (!unique.some(u => u.id === item.id)) {
            unique.push(item);
          }
          return unique;
        }, []);
        that.total = that.tableData.length;
      } else {
        that.total = 0;
        that.tableData = [];
      }
    },
    handleSizeChange(val) {
      this.limit = val;
      if (this.currentTab === 'keyword') {
        this.getRankKeywords(this.instrument_id)
      } else if (this.currentTab === 'scene') {
        this.getRankScene(this.instrument_id)
      }  else if (this.currentTab === 'brand') {
        this.getRankBrand(this.instrument_id)
      } else if (this.currentTab === 'contact') {
        this.getContactList()
      } else {
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      if (this.currentTab === 'keyword') {
        this.getRankKeywords(this.instrument_id)
      } else if (this.currentTab === 'scene') {
        this.getRankScene(this.instrument_id)
      }  else if (this.currentTab === 'brand') {
        this.getRankBrand(this.instrument_id)
      } else if (this.currentTab === 'contact') {
        this.getContactList()
      } else {
      }
    },
    //详情
    printscreenClick(val){
      let that = this;
      that.detailsContObj.keywords = '';
      that.detailsContObj.instrument_id = val.instrument_id;
      that.detailsContObj.answer = '';
      let id = val.rank_search_id;
      let data = {
        code: that.code,
        rank_search_id:val.rank_search_id
      }
      axios.get(this.url + '/answer',
        {
          params: data
        },
      )
        .then(function (res) {
          let data = res.data;
            if (data.code == 1) {
              that.detailsContObj.keywords = data.data.keywords;
              that.detailsContObj.answer = data.data.answer;
              const hasContact = that.checkContactInfo(data.data.answer);
              if (hasContact) {
                // 执行相关逻辑
                console.log('检测到联系方式');
                // 确保不会重复添加
                if (!that.contactIdList.includes(id)) {
                  that.contactIdList.push(id);
                }
              }
            }
        })
      this.dialogVisible = true;
    },
    checkContactInfo(content) {
      if (!content) return false;
      // 移除HTML标签
      const text = content.replace(/<[^>]*>/g, '');
      // 检查联系方式关键词
      const contactPatterns = [
        '联系方式',
        '联系电话',
        '电话',
        '手机',
        '微信',
        '邮箱',
        'QQ',
        '热线'
      ];

      // 检查电话号码格式
      const phonePattern = /(1[3-9]\d{9})|(\d{3,4}-\d{7,8})/g;
      const hasPhone = phonePattern.test(text);

      // 检查邮箱
      const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
      const hasEmail = emailPattern.test(text);

      // 检查关键词
      const hasKeyword = contactPatterns.some(pattern => text.includes(pattern));

      return hasKeyword || hasPhone || hasEmail;
    },
    handleSizeSemanticSearchChange(val) {
      this.semanticSearchLimit = val;
      this.getRankScene();
    },
    handleCurrentSemanticSearchChange(val) {
      this.semanticSearchPage = val;
      this.getRankScene();
    },
    //获取地址栏参数
    getQueryString(name) {
      var reg = new RegExp("(?:\\?|&|#|^)" + name + "=([^&]*)(?:&|$|#)", "i");
      var match = window.location.href.match(reg);
      return match ? decodeURIComponent(match[1]) : null;
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      localStorage.setItem('ismobile', flag ? 1 : 0);
      let goUrl = flag ? 1 : 0;
      return goUrl;
    },
    //获取窗口宽度
    getWindowWidth() {
      return window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    // 移除resize监听
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    if (this.chart) {
      this.chart.dispose()
    }
  },

}
</script>
<style scoped lang="scss">
.navBar {
  width: 100%;
  display: flex;
  justify-content: start;
  padding: 0 14px;
  height: 75px;
  background: url("../assets/img/07.png") no-repeat center;
  background-size: 100% 100%;

  .navBarLeft {
    width: 31%;

    p:nth-child(1) {
      width: 93px;
      height: 26px;
      margin: 10px 0 10px 10px;
    }
  }

  .navBarCenter {
    width: 38%;
    color: #333;
    font-weight: bold;

    p {
      margin-top: 12px;
      font-size: 28px;
      text-align: center;
    }
  }

  .navBarRight {
    width: 31%;
    color: #36208B;
    line-height: 15px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    p:nth-child(1) {
      margin-right: 15px;
    }
  }

}

.homePageCont {
  padding: 0 22px;
  margin-top: 40px;

  .enterpriseInformation {
    height: 150px;
    background: url("../assets/img/29.png") no-repeat center;
    background-size: 100% 100%;
    padding: 10px 20px;

    .enterpriseInformationContTop {
      display: flex;
      justify-content: start;
      align-items: center;
      padding: 20px 0;
      margin-bottom: 10px;

      span:nth-child(1) {
        display: inline-block;
        width: 56px;
        height: 35px;
        img {
          width: 100%;
        }
      }

      span:nth-child(2) {
        color: #333;
        font-size: 22px;
        margin-left: 20px;
      }
    }

    .enterpriseInformationContBot {
      display: flex;
      justify-content: start;
      align-items: center;
      padding-left: 15px;
      float: left;
      span:nth-child(1) {
        display: inline-block;
        width: 20px;
        height: 20px;
      }

      span:nth-child(2) {
        color: #333;
        margin-left: 10px;
        display: inline-block;
        width: 60px;
      }
    }
  }

  .enterpriseInformationTitle {
    p:nth-child(1) {
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      line-height: 30px;
      margin-bottom: 5px;
    }

    p:nth-child(2) {
      height: 1px;
      background: url("../assets/img/18.png") no-repeat center;
      background-size: 100% 100%;
    }
  }

  .keywordNum {
    height: 150px;
    margin-bottom: 10px;
    .keywordNumTitle{
      p:nth-child(1) {
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
        margin-bottom: 5px;
      }
    }
    .keywordNumCont {
      //padding: 40px 22px 20px 22px;
      ul {
        overflow: hidden;
        li {
          width: 24%;
          height: 130px;
          float: left;
          position: relative;
          padding: 20px 25px;
          p:nth-child(2) {
            color: #3E2A53;
            font-weight: bold;
            font-size: 18px;
            margin-top: 10px;
          }
          p:nth-child(1) {
           color: #333;
          }

        }
        li:nth-child(1) {
          background: url("../assets/img/30.png") no-repeat center;
          background-size: 100% 100%;
        }
        li:nth-child(2) {
          background: url("../assets/img/31.png") no-repeat center;
          background-size: 100% 100%;
        }
        li:nth-child(3) {
          background: url("../assets/img/32.png") no-repeat center;
          background-size: 100% 100%;
        }
        li:nth-child(4) {
          background: url("../assets/img/33.png") no-repeat center;
          background-size: 100% 100%;
        }

      }
    }
  }
  .titleLine{
    display: inline-block;
    width: 4px;
    height: 18px;
    background: #8D7DFE;
    border-radius: 2px;
    vertical-align: middle;
    margin-right: 10px;
  }
  .keywordRecordData, .rankingPercentageData {
    height: 300px;
    box-shadow: 2px 4px 8px 0px rgba(141, 112, 254, 0.18);
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 0.5); /* 半透明白色 */
  }
.keywordRecordData{
  height: 300px;
}
  .keywordRecordDataCont{
    height: 252px;
    overflow-y: auto;
    /* 启用字体抗锯齿 */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;

    /* 确保Canvas显示清晰 */
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
  /*修改滚动条样式*/
  .keywordRecordDataCont::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: rgba(146, 146, 146, 0.3);
    border-radius: 2px;
  }
  .keywordRecordDataCont::-webkit-scrollbar-thumb {
    background-color: rgba(146, 146, 146, 0.3);
    border-radius: 2px;
  }
  /* 容器样式优化 */
  .canvas-container {
    //background: linear-gradient(to bottom, #f0f8ff, #ffffff); /* 浅蓝到白色渐变背景 */
    padding: 15px;
    //border-radius: 8px;
    //box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  .rankingPercentageData{
    margin: 20px 0;
  }
  .rankingPercentageDataCont {
    position: relative;

    .rankingPercentageDataContImg {
      position: absolute;
      left: 40.5%;
      top: 39%;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      padding: 10px;
      border: 1px dashed #BBAAFF;
    }
  }

  .articleDataList {
    padding: 0 15px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333;
      font-size: 16px;
      padding: 22px 0;

      p:nth-child(1) {
        display: flex;
        justify-content: start;
        align-items: center;

        span:nth-child(1) {
          display: inline-block;
          width: 60px;
          height: 60px;
        }
      }
    }

    .cutOffLine {
      height: 1px;
      background: url("../assets/img/18.png") no-repeat center;
      background-size: 100% 100%;
    }
  }

  .dataTitle {
    color: #333333;
    font-weight: bold;
    line-height: 48px;
    background: linear-gradient(-11deg, #C9BBFF 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 16px 16px 0 0;
    padding-left: 15px;
  }

  .homePageContList {
    margin: 20px 0;
    //min-height: 1100px;
    background: linear-gradient(177deg, rgba(201, 187, 255, 0.3) 0%, rgba(255, 255, 255, 1) 100%);
    box-shadow: 2px 4px 8px 0 rgba(141, 112, 254, 0.18);
    border-radius: 16px;

    .search-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
    }

    /* 选项基础样式 */
    .search-option {
      font-size: 18px;
      font-weight: bold;
      color: #333; /* 默认深灰色 */
      cursor: pointer;
      padding-bottom: 8px; /* 为虚线预留空间 */
      position: relative;
      transition: color 0.3s;
      margin: 0 10px;
    }

    /* 选中状态样式 */
    .search-option.active {
      color: #8D7DFE; /* 淡紫色 */
    }

    /* 选中状态下的虚线 */
    .search-option.active::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 30px;
      height: 2px;
      background: url("../assets/img/23.png") no-repeat center;
      background-size: 100% 100%; /* 控制虚线间隔 */
    }

    .semanticSearchList {
      padding: 0 20px;

      li {
        padding: 0 20px;
        line-height: 45px;
        color: #3B3A41;
        font-size: 14px;
      }

      .semanticSearchListLi:nth-child(odd) {
        background: rgba(242, 238, 255, 0.6);
        //box-shadow: 0px 1px 0px 0px #8D70FE;
        border-top: 1px solid #F2EEFF;
      }

      .semanticSearchListLi:nth-child(even) {
        background: #fff;
      }
    }
  .screeningCondition{
    display: flex;
    justify-content: space-between;
    align-content: center;
    //margin-bottom: 10px;
    padding: 0 20px;
    /deep/ .el-input--suffix .el-input__inner{
      border: 1px solid #8D7DFE;
      background: transparent;
    }
    /deep/ .el-button{
      background: transparent;
      border-color: #8D7DFE;
      padding: 8px 15px;
    }
    /deep/ .el-button.activeSource{
      background: #8D7DFE !important;
      color: #fff;
    }
  }
  }

}

/deep/ .el-tabs--border-card {
  background: url("../assets/img/21.png") no-repeat center;
  background-size: 100% 100%;
  border-radius: 16px 16px 0px 0px;
}

/deep/ .el-tabs--border-card > .el-tabs__header {
  background: transparent;
  border-bottom: 0 !important;
}

/deep/ .el-tabs__item {
  padding: 0 50px;
  height: 45px;
  line-height: 45px;
}

/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: #7B7086;
  font-weight: bold;
  font-size: 16px;
}

/deep/ .el-tabs--border-card > .el-tabs__content {
  padding: 0;
}

/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: transparent;
  background: url("../assets/img/22.png") no-repeat center;
  background-size: 100% 100%;
  color: #602C86;
}

/deep/ .el-table thead {
  color: #000;
}

/deep/ .el-table th, .el-table tr {
  background: rgba(201, 187, 255, 0.5);
}

/deep/ .el-table th > .cell {
  border-right: 1px solid #C9BBFF;
}

/deep/ .el-table th:nth-child(6) > .cell {
  border-right: none;
}

/* 偶数行背景色（浅紫色） */
.el-table /deep/ .odd-row td {
  background-color: rgba(235, 230, 255, 0.3) !important; /* 或使用图中的渐变色 */
}
/deep/ .el-table__body-wrapper{
  height: 351px;
  overflow-y: auto;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background-color: rgba(146, 146, 146, 0.3);
  border-radius: 2px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(146, 146, 146, 0.3);
  border-radius: 2px;
}
/deep/ .el-pagination {
  text-align: center;
  padding: 20px 5px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #9276FE;
}
/* 修改placeholder颜色 */
/deep/ .custom-select .el-input__inner::placeholder {
  color: #606266;
  opacity: 1; /* 确保在Firefox中显示 */
}

/* 鼠标悬停时的placeholder颜色 */
/deep/ .custom-select .el-input__inner:hover::placeholder {
  color: #606266;
}

/* 聚焦时的placeholder颜色 */
/deep/ .custom-select .el-input__inner:focus::placeholder {
  color: #606266;
}
/deep/ .el-select .el-input .el-select__caret{
  color: #606266;
}
@media screen and (max-width: 1101px) {
  .homePageCont .enterpriseInformation .enterpriseInformationContTop span[data-v-a83bd3b0]:nth-child(2){
    font-size: 16px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1200px) {
  .homePageCont .enterpriseInformation .enterpriseInformationContTop span[data-v-a83bd3b0]:nth-child(2){
    font-size: 18px;
  }
}
@media screen and (min-width: 1201px) and (max-width: 1330px) {
  .homePageCont .enterpriseInformation .enterpriseInformationContTop span[data-v-a83bd3b0]:nth-child(2){
    font-size: 20px;
  }
}
@media screen and (min-width: 1520px) and (max-width: 1600px) {
  .homePageCont .rankingPercentageDataCont .rankingPercentageDataContImg {
    left: 41.5%;
  }
}

@media screen and (min-width: 1601px) and (max-width: 1820px) {
  .homePageCont .rankingPercentageDataCont .rankingPercentageDataContImg {
    left: 42.5%;
  }
}

@media screen and (min-width: 1821px) and (max-width: 1920px) {
  .homePageCont .rankingPercentageDataCont .rankingPercentageDataContImg {
    left: 43.5%;
  }
}
.canvas-container {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.specialDeclaration{
  width: 100%;
  text-align: center;
  color: #3E2A53;
  font-size: 14px;
  line-height: 15px;
}
.detailsCont{
  padding: 20px;
  box-sizing: border-box;
  background: #F9F9F9;
  border-radius: 8px;
  .detailsContKeywords{
    width: 100%;
    overflow: hidden;
    span{
      display: inline-block;
      float: right;
      background: #F0F1FF;
      padding: 10px 16px;
      box-sizing: border-box;
      font-size: 14px;
      color: #333;
    }
  }
  .detailsContPlatform{
    img{
      width: 24px;
      vertical-align: bottom;
    }
  }
  .detailsContAnswer{
    background: #FFFFFF;
    border-radius: 0 12px 12px;
    line-height: 24px;
    font-size: 14px;
    color: #333;
    padding: 12px 20px;
    box-sizing: border-box;
    margin-top: 10px;
  }
}
/deep/ .el-dialog{
  margin-top: 3vh !important;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue